<template>
  <div class="rule-tpl-edit">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="panel-box rule-tpl-edit-btn-area">
      <el-button class="eb-button-orange eb-button-big" @click="goTemplateListPage()">返回</el-button>
      <el-button class="eb-button-orange eb-button-big" @click="showEditTplWindow()">修改</el-button>
      <el-button class="eb-button-orange eb-button-big" @click="showImportTplWindow()">导入</el-button>
      <el-button class="eb-button-orange eb-button-big" @click="exportTpl()">导出</el-button>
      <el-button class="eb-button-orange eb-button-big" @click="switchRuleDigitalSort">规则排序</el-button>
    </div>
    <div class="panel-box expand-icon-container">
      <i class="icon iconfont icon-piliangzengjia" @click="expandAll()"></i>
      <span @click="expandAll()">&nbsp;全部展开</span>
      &nbsp;
      <i class="icon iconfont icon-batch-reduce" @click="collapseAll()"></i>
      <span @click="collapseAll()">&nbsp;全部收起</span>
    </div>
    <div class="panel-box">
      <RuleTemplateBaseInfo :ruleTemplate="ruleTemplate" />
    </div>
    <div class="eb-line"></div>
    <div class="panel-box" v-show="isShowRuleDigitalSort">
      <RuleDigitalSort :ruleList="ruleDigitalData" />
    </div>
    <RuleDigitalEditList v-show="!isShowRuleDigitalSort" ref="ruleDigitalEditList" :ruleList="ruleDigitalData" :isExpandAll="isExpandAll" />
    <RuleDigitalImportDialog @onSuccess="ruleDigitalImportSuccess" :isVisible.sync="isTplImportVisible" :importUrl="importUrl" :data="importData" />
    <RuleTemplateEditDialog @ruleTmeplateSuccess="ruleTmeplateSuccess" :isVisible.sync='dialogVisible' :ruleTemplateInfo='ruleTemplateInfo' />
  </div>
</template>
<script>
import EventBus from '@/plugins/event-bus';
import EbHeader from '@/components/common/eb-header';
import EbBreakCrumb from '@/components/common/eb-break-crumb';
import RuleTemplateBaseInfo from '@/components/ruletemplate/view/RuleTemplateBaseInfo';
import RuleDigitalEditList from '@/components/ruletemplate/edit/RuleDigitalEditList';
import { getRuleTemplateById, isDefRuleTemplateName } from '@/services/rule/rule-template-service';
import { listDigital, handleRuleDigitalList } from '@/services/rule/rule-digital-service';
import { downloadFile } from '@/plugins/download-file';
import { baseURL } from '@/plugins/axios';
import RuleTemplateEditDialog from '@/components/ruletemplate/edit/RuleTemplateEditDialog';

export default {
  name: '',
  components: {
    EbHeader,
    EbBreakCrumb,
    RuleTemplateBaseInfo,
    RuleDigitalEditList,
    RuleDigitalImportDialog: () => import('@/components/ruletemplate/edit/RuleDigitalImportDialog'),
    RuleDigitalSort: () => import('@/components/ruletemplate/edit/RuleDigitalSort'),
    RuleTemplateEditDialog
  },
  filters: {},
  data() {
    return {
      templateId: this.$route.params.templateId,
      ruleTemplate: {},
      isExpandAll: true,
      ruleDigitalData: [],
      isTplImportVisible: false,
      importUrl: baseURL + '/api/ruleTemplate/import',
      importData: {},
      isShowRuleDigitalSort: false,
      dialogVisible: false,
      ruleTemplateInfo: {
        operType: 'edit',
        isCanEditTplName: true,
        templateId: null,
        templateCode: null,
        templateName: null,
        templateMemo: null,
        publicState: null
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$root.layout.isLoading = false;
    this.initRuleTemplate();
    this.initRuleDigitalData();

    // 修改规则列表
    EventBus.$on('reloadRuleDigitalList', async (params, done) => {
      this.initRuleDigitalData();
      this.isShowRuleDigitalSort = false;
    });
  },
  mounted() {},
  methods: {
    async initRuleTemplate() {
      try {
        let { data } = await getRuleTemplateById(this.templateId);
        if (data.returnCode === '01') {
          this.ruleTemplate = data.ruleTemplate;
        } else {
          this.$message.error('加载模板信息失败');
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async initRuleDigitalData() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listDigital({ templateId: this.templateId });
        if (data.returnCode === '01') {
          this.ruleDigitalData = handleRuleDigitalList(data.digitalList);
        } else {
          this.$message.error('加载模板规则失败');
        }
      } catch (error) {
        this.$message.error(error);
      }
      this.$root.layout.isLoading = false;
    },
    goTemplateListPage() {
      this.$router.push({ path: '/v2/rule/template/list' });
    },
    showEditTplWindow() {
      this.ruleTemplateInfo.templateId = this.ruleTemplate.templateId;
      this.ruleTemplateInfo.templateName = this.ruleTemplate.templateName;
      this.ruleTemplateInfo.templateMemo = this.ruleTemplate.templateMemo;
      this.ruleTemplateInfo.publicState = this.ruleTemplate.publicState;
      this.ruleTemplateInfo.operType = 'edit';
      // 判断模板名称是否可以修改
      if (isDefRuleTemplateName(this.ruleTemplate.templateName)) {
        this.ruleTemplateInfo.isCanEditTplName = false;
      } else {
        this.ruleTemplateInfo.isCanEditTplName = true;
      }
      this.dialogVisible = true;
    },
    showImportTplWindow() {
      // this.importUrl =  + '&templateId=' + this.templateId + '&templateName=' + this.ruleTemplate.templateName;
      this.importData = {
        channel: 'rule_digital_import',
        templateId: this.templateId,
        templateName: this.ruleTemplate.templateName
      };
      this.isTplImportVisible = true;
    },
    exportTpl() {
      downloadFile(baseURL + '/api/ruleTemplate/export?templateId=' + this.templateId, this.ruleTemplate.templateName + '.xml');
    },
    switchRuleDigitalSort() {
      if (this.isShowRuleDigitalSort) {
        this.isShowRuleDigitalSort = false;
      } else {
        this.isShowRuleDigitalSort = true;
        EventBus.$emit('initRuleDigitalSortList');
      }
    },
    expandAll() {
      this.$refs.ruleDigitalEditList.expandAll();
    },
    collapseAll() {
      this.$refs.ruleDigitalEditList.collapseAll();
    },
    ruleTmeplateSuccess: function() {
      this.initRuleTemplate();
    },
    ruleDigitalImportSuccess() {
      this.initRuleTemplate();
      this.initRuleDigitalData();
      this.isTplImportVisible = false;
    }
  },
  beforeDestroy() {
    EventBus.$off('reloadRuleDigitalList');
  }
};
</script>
<style lang="less">
.rule-tpl-edit {
  .rule-tpl-edit-btn-area {
    padding: 20px 0px;
  }
  .expand-icon-container {
    padding: 0px;
    margin-bottom: -15px;
    .iconfont {
      cursor: pointer;
      color: tomato;
      font-size: 24px;
    }
    span {
      cursor: pointer;
      color: tomato;
      font-size: 14px;
      position: relative;
      top: -3px;
    }
  }
}
</style>
